import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FaShoppingCart, FaStar } from 'react-icons/fa';
import { useCart } from '../context/CartContext';

function Cart() {
  const { cartItems, removeFromCart, updateQuantity, getCartTotal } = useCart();

  if (cartItems.length === 0) {
    return (
      <div className="container cart-page" style={{ textAlign: 'center' }}>
        <Helmet>
          <title>Handlekurv - HeroPixelLab</title>
          <link href="https://heropixellab.com/cart/" rel="canonical"/>
        </Helmet>
        <FaShoppingCart style={{ fontSize: '80px', color: '#00e5ff', marginBottom: '30px' }} />
        <h1 style={{ color: '#00e5ff', marginBottom: '20px' }}>Din handlekurv er tom</h1>
        <p style={{ color: '#e0e0e0', marginBottom: '30px' }}>Se vårt utvalg av fantastiske spill og legg dine favoritter i handlekurven.</p>
        <Link to="/" className="detail-button add-to-cart">Gå til butikken</Link>
        <div className="page-number">Side 6</div>
      </div>
    );
  }

  return (
    <div className="container cart-page">
      <Helmet>
        <title>Handlekurv - HeroPixelLab</title>
      </Helmet>
      <h1 className="cart-title">Din Handlekurv</h1>

      {cartItems.map((item) => (
        <div className="cart-item" key={item.id}>
          <div className="cart-item-info">
            <img src={item.image} alt={item.name} className="cart-item-image" />
            <div>
              <p className="cart-item-name">{item.name}</p>
              <div className="product-rating">
                {[...Array(5)].map((_, index) => (
                  <FaStar key={index} color={index < Math.floor(item.rating) ? '#ffd700' : '#555'} size={12} />
                ))}
              </div>
              <p className="cart-item-price">kr {item.price},-</p>
            </div>
          </div>
          <div className="quantity-control">
            <button className="quantity-button" onClick={() => updateQuantity(item.id, item.quantity - 1)}>-</button>
            <span>{item.quantity}</span>
            <button className="quantity-button" onClick={() => updateQuantity(item.id, item.quantity + 1)}>+</button>
            <button className="remove-button" onClick={() => removeFromCart(item.id)}>Fjern</button>
          </div>
        </div>
      ))}

      <div style={{ textAlign: 'right', marginTop: '30px' }}>
        <p style={{ fontSize: '24px', marginBottom: '20px' }}>
          Totalt: <span style={{ color: '#00e5ff', fontWeight: '700' }}>kr {getCartTotal()},-</span>
        </p>
        <Link to="/checkout" className="detail-button add-to-cart">Gå til kassen</Link>
      </div>

      <div className="page-number">Side 6</div>
    </div>
  );
}

export default Cart;